import { Component, Input, OnInit } from '@angular/core';
import { IUploadConfig, UPLOAD_CONFIG } from './upload-config';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'upload-example-template',
  template: `
    <span data-cy="example-template" [innerHTML]="'GA.UPLOADS.EXAMPLE_TEMPLATE' | translate: { url: templateUrl }"></span>
    <span *ngIf="downloadTemplateForUploadUrl"><br><span data-cy="download-template" [innerHTML]="'GA.UPLOADS.EXPORT_DATA' | translate: { url: downloadTemplateForUploadUrl }"></span></span>
  `
})
export class UploadExampleTemplateComponent implements OnInit {
  @Input() public code:string;
  public templateUrl:string;
  public downloadTemplateForUploadUrl:string;
  private uploadConfig:IUploadConfig;
  
  
  constructor(
    private stateService:StateService
  ) {
  }
  public ngOnInit():void {
    // generate template url
    this.uploadConfig = UPLOAD_CONFIG[this.code];
    this.templateUrl = `rest/uploads/template/generate?templateName=${this.uploadConfig?.uploadTemplateCode}`;
    this.downloadTemplateForUploadUrl = this.getDownloadUrl();  
  }

  private getDownloadUrl():string {
    if (!this.uploadConfig) {
      return '';
    } 
    return this.stateService.href(
      this.uploadConfig.downloadDataUrl?.stateName, 
      this.uploadConfig.downloadDataUrl?.stateParams
    );
  }
}